export type Direct = 'direct';
export type OneStop = 'oneStop';
export type TwoPlusStops = 'twoPlusStops';
export type StopsID = Direct | OneStop | TwoPlusStops;
export const DIRECT: Direct = 'direct';
export const ONE_STOP: OneStop = 'oneStop';
export const TWO_PLUS_STOPS: TwoPlusStops = 'twoPlusStops';
